import PhoneNumber from './PhoneNumber';
export default function getExampleNumber(country, examples, metadata) {
  if (examples[country]) {
    return new PhoneNumber(country, examples[country], metadata);
  }
}
//# sourceMappingURL=getExampleNumber.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/es6/getExampleNumber.js
// module id = ./node_modules/libphonenumber-js/es6/getExampleNumber.js
// module chunks = 0 1 2 3